export default {
  header: 'Informácie o mieste "{place}"',
  placeStatus: 'Stav miesta',
  reserved: 'Rezervované',
  holdingTime: 'Čas udržiavania [min]',
  loadStatus: 'Stav vsázky',
  cellLoadNo: 'Číslo vsázky bunky',
  targetStartTime: 'Cieľový čas spustenia',
  bookedOnPlace: 'Rezervované na mieste',
  plcLoadNo: 'Číslo vsázky PLC',
  box: 'Box',
  prio: 'Priorita',
  comment: 'Komentár',
  noActiveProcessFlow: 'Žiadny aktívny tok procesu',
  noParts: 'Žiadne diely',
  processFlow: 'Tok procesu',
  content: 'Obsah',
  confirmStartProcessFlowNow: 'Naozaj chcete teraz spustiť tok procesu?',
  name: 'Názov',
  description: 'Popis',
  booked: 'Rezervované',
  modification: 'Modifikácia',
  unloaded: 'Vyložené',
  started: 'Spustené',
  finished: 'Dokončené',
  loadFinalTest: 'Záverečný test vsázky',
  status: 'Stav',
  parts: 'Diely',
  loadingPlace: 'Miesto zakladania',
};
